import React from 'react';

interface Props {
  color?: string;
  className?: string;
}

export function IconSearch(props: Props) {
  const { color = '#f97316', className = '' } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.66146 14.0026C11.1593 14.0026 13.9948 11.1671 13.9948 7.66927C13.9948 4.17147 11.1593 1.33594 7.66146 1.33594C4.16366 1.33594 1.32812 4.17147 1.32812 7.66927C1.32812 11.1671 4.16366 14.0026 7.66146 14.0026Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M14.6719 14.6641L12.6719 12.6641"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}
